<template>
  <div>
    <container-headline
      :headline="$t('global.masterdata')"
      :col="6"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="col-xl-4">
              <div class="form-group">
                <ValidationProvider
                  rules="required"
                  immediate
                  v-slot="{ passed }"
                >
                  <input
                    v-model.trim="veranstaltung.kuerzel"
                    class="form-control"
                    placeholder=" "
                    v-bind:class="{ 'border-danger': !passed }"
                    :readonly="!editable"
                  />
                  <label v-bind:class="{ 'text-danger': !passed }">{{
                    $t("global.shortdesignation")
                  }}</label>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-xl-8">
              <div class="form-group">
                <ValidationProvider
                  rules="required"
                  immediate
                  v-slot="{ passed }"
                >
                  <input
                    v-model.trim="veranstaltung.bezeichnung"
                    class="form-control"
                    placeholder=" "
                    v-bind:class="{ 'border-danger': !passed }"
                    :readonly="!editable"
                  />
                  <label v-bind:class="{ 'text-danger': !passed }">{{
                    $t("global.designation")
                  }}</label>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <v-select
                  v-model="veranstaltung.veranstaltungsstatus"
                  label="bezeichnung"
                  :options="veranstaltungsstati"
                  :disabled="isAdmin ? false : !editable"
                  :placeholder="$t('global.status')"
                >
                  <span slot="no-options">{{ $t("global.taptosearch") }}</span>
                </v-select>
                <label>{{ $t("global.status") }}</label>
              </div>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <v-select
                  v-model="veranstaltung.lehrmethode"
                  label="bezeichnung"
                  :options="lehrmethoden"
                  :disabled="!editable"
                  :placeholder="$t('global.teachingmethod')"
                >
                  <span slot="no-options">{{ $t("global.taptosearch") }}</span>
                </v-select>
                <label>{{ $t("global.teachingmethod") }}</label>
              </div>
            </div>
          </div>
          <div class="row" v-if="!isTemplate">
            <div class="col-xl-3">
              <div class="form-group">
                <ValidationProvider
                  :name="$t('global.startdatum')"
                  vid="startdatum"
                  immediate
                  v-slot="{ passed, errors }"
                >
                  <date-picker
                    date-format="dd.mm.yy"
                    v-model ="veranstaltung.startdatum"
                    placeholder=" "
                    :show-icon="true"
                    :disabled="!editable"
                    :validation="passed"
                  />
                  <label>{{ $t("global.start") }}</label>
                  <small class="text-danger">{{  errors[0]  }}</small>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-xl-3">
              <div class="form-group">
                 <ValidationProvider
                  :name="$t('global.enddatum')"
                  vid="endatum"
                  rules="datumNichtVorStart:@startdatum"
                  immediate
                  v-slot="{ passed, errors }"
                >
                  <date-picker
                    date-format="dd.mm.yy"
                    v-model="veranstaltung.enddatum"
                    placeholder=" "
                    :show-icon="true"
                    :disabled="!editable"
                    :validation="passed"
                  />
                  <label>{{ $t("global.end") }}</label>
                  <small class="text-danger">{{  errors[0]  }}</small>
                 </ValidationProvider>
              </div>
            </div>
            <div class="col-xl-6">
              <single-select-person
                id="verantwortlicher"
                :person="veranstaltung.verantwortlicher"
                :label="$t('global.responsible')"
                :allowOpen="true"
                :editable="editable"
                :required="false"
                @confirmed="setVerantwortlicher"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <textarea
                  v-model.trim="veranstaltung.beschreibung"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                ></textarea>
                <label>{{ $t("global.description") }}</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-4">
              <div class="form-group">
                <ValidationProvider
                  rules="required"
                  immediate
                  v-slot="{ passed }"
                >
                  <v-select
                    v-model="veranstaltung.veranstaltungstyp"
                    label="bezeichnung"
                    :options="veranstaltungstypen"
                    :disabled="!editable"
                    :placeholder="$t('global.eventtype')"
                    :class="{ 'border rounded border-danger': !passed }"
                  >
                    <span slot="no-options">{{
                      $t("global.taptosearch")
                    }}</span>
                  </v-select>
                  <label v-bind:class="{ 'text-danger': !passed }">{{
                    $t("global.eventtype")
                  }}</label>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-xl-4">
              <div class="form-group">
                <v-select
                  v-model="veranstaltung.periode"
                  label="bezeichnung"
                  :options="perioden"
                  :disabled="!editable"
                  :placeholder="$t('global.semester')"
                >
                  <span slot="no-options">{{ $t("global.taptosearch") }}</span>
                </v-select>
                <label>{{ $t("global.semester") }}</label>
              </div>
            </div>
            <div class="col-xl-4">
              <div class="form-group">
                <v-select
                  v-model.trim="veranstaltung.color"
                  :options="colorOptions"
                  label="label"
                  :reduce="(o) => o.value"
                  :disabled="!editable"
                  :clearable="true"
                  :placeholder="$t('global.color')"
                >
                  <template v-slot:option="opt">
                    <div class="d-flex align-items-center">
                      <span
                        class="color-swatch mr-2"
                        :style="{ backgroundColor: opt.value }"
                      ></span>
                      <span>{{ opt.label }}</span>
                    </div>
                  </template>
                  <template v-slot:selected-option="opt">
                    <div class="d-flex align-items-center">
                      <span
                        class="color-swatch mr-2"
                        :style="{ backgroundColor: opt.value }"
                      ></span>
                      <span>{{ opt.label }}</span>
                    </div>
                  </template>
                  <span slot="no-options">{{ $t("global.taptosearch") }}</span>
                </v-select>
                <label>{{ $t("global.color") }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";

import { LADE_AUSWAHLWERTE_VERANSTALTUNG } from "@/store/veranstaltung/actions.type";

import DatePicker from "@/components/Datepicker";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import { extend } from 'vee-validate'

export default {
  name: "veranstaltungStammdaten",
  components: {
    ContainerHeadline,
    DatePicker,
    SingleSelectPerson,
  },
  props: {
    isTemplate: {
      type: Boolean,
      required: true,
    },

    veranstaltungstypen: {
      type: Array,
      required: false,
    },

    veranstaltung: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      kurstyp: null,
      colorOptions: [
        { label: 'Hellblau', value: '#E3F2FD' },
        { label: 'Eisblau', value: '#E1F5FE' },
        { label: 'Mint', value: '#E0F2F1' },
        { label: 'Türkis hell', value: '#E0F7FA' },
        { label: 'Hellgrün', value: '#E8F5E9' },
        { label: 'Limette hell', value: '#F1F8E9' },
        { label: 'Gelb sehr hell', value: '#FFFDE7' },
        { label: 'Apricot', value: '#FFF3E0' },
        { label: 'Pfirsich', value: '#FFE0B2' },
        { label: 'Rosé', value: '#FCE4EC' },
        { label: 'Flieder', value: '#F3E5F5' },
        { label: 'Lavendel', value: '#EDE7F6' },
        { label: 'Blaugrau', value: '#ECEFF1' },
        { label: 'Beige', value: '#EFEBE9' },
        { label: 'Hellrot', value: '#FFEBEE' },
      ],
    };
  },
  watch: {
    veranstaltungsstati: function (val) {
      if (val && !this.veranstaltung.veranstaltungsstatus) {
        let veranstaltungStatusOffen = this.$CONST("VERANSTALTUNGSSTATI").OPEN;

        this.veranstaltung.veranstaltungsstatus = this.veranstaltungsstati.find(
          ({ id }) => id == veranstaltungStatusOffen
        );
      }
    },
    kurstyp: function (val) {
      this.$bus.$emit("setKurstyp", val);
    },
    periode: function (val) {
      this.veranstaltung.periode = val;
    },
  },
  created() {
    extend("datumNichtVorStart", {
      params: ["start"],
      validate: (value, { start }) => {
        if (!value || !start) return true

        const parse = (d) => {
          const [tag, monat, jahr] = d.split(".")
          return new Date(Number(jahr), Number(monat) -1, Number(tag))
        }

        return parse(value) >= parse(start)
      },
      message: this.$t("global.enddatenotbeforestartdate"),
    })
  },
  computed: {
    veranstaltungsstati: {
      get() {
        return this.$store.state.veranstaltung.veranstaltungsstati;
      },
    },
    lehrmethoden: {
      get() {
        return this.$store.state.veranstaltung.lehrmethoden;
      },
    },
    perioden: {
      get() {
        return this.$store.state.veranstaltung.perioden;
      },
    },
  },
  mounted: function () {
    if (this.veranstaltungsstati.length == 0)
      this.$store.dispatch(`veranstaltung/${LADE_AUSWAHLWERTE_VERANSTALTUNG}`);

    this.isAdmin =
      this.gruppen.findIndex(
        (gruppe) => gruppe.id == this.$CONST("GRUPPEN").ADMIN
      ) == -1
        ? false
        : true;
  },
  methods: {
    setVerantwortlicher(person) {
      this.veranstaltung.verantwortlicher = person;
    },
  },
};
</script>

<style lang="scss">
.color-swatch {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
</style>
